import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import PrivacyPolicyModal from "../model/PrivacyPolicyModal";
import CookiePolicyModal from "../model/CookiePolicyModal";
import TermsModal from "../model/TermsModal";

function Footer() {
  const navigate = useNavigate();
  const [emaildata, setEmaildata] = useState("");
  const [PrivacyPolicyModalstate, SetPrivacyPolicyModalstate] = useState(false);
  const [CookiePolicyModalstate, setCookiePolicyModalState] = useState(false);
  const [TermsModalstate, SetTermsModalstate] = useState(false);

  function isValidEmail(emaildata) {
    return /\S+@\S+\.\S+/.test(emaildata);
  }

  const handleSendEmail = () => {
    if (!emaildata) {
      toast.error("Please enter your Email");
    } else if (!isValidEmail(emaildata)) {
      toast.error("Please enter valid Email");
    } else {
      axios
        .post("https://backend.kindlebit.com/api/newletters", {
          email: emaildata,
        })
        .then(function (response) {
          if (response?.data?.message === "Your email id already exists!") {
            toast.success("You already connect with our news letters");
            setEmaildata("");
          } else {
            toast.success("Thank you");
            setEmaildata("");
          }
        })
        .catch(function (error) {
          console.log("error", error);
        });
    }
  };

  return (
    <>
      <footer className="dark" id="dark3">
        <div className="footer-inner container">
          <div className="foot-left">
            <div className="foot-kbit-info">
              <div className="kbit-logo" onClick={() => navigate("/")}>
                <img
                  src="/assets/images/logo-light.svg"
                  alt="./images/career-ban.png"
                  loading="lazy"
                  height={60}
                  width={202}
                />
              </div>
              <div className="kbit-con">
                The foundation of business growth lies in a winning combination
                of expertise and innovation. Kindlebit Solutions leverages the
                power of both digital and human experiences to drive success for
                businesses.
              </div>
            </div>
            <div className="foot-links-head">
              <div className="foot-links-inner">
                <ul>
                  <li className="sap-sm-heading">Services</li>
                  <li>
                    <Link
                      to="/design"
                      onClick={() =>
                        window.scroll({
                          top: 0,
                          behavior: "instant",
                        })
                      }
                      aria-label="Visit Design Page"
                      rel="preload"
                    >
                      Design
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/development"
                      onClick={() =>
                        window.scroll({
                          top: 0,
                          behavior: "instant",
                        })
                      }
                      aria-label="Visit Development Page"
                      rel="preload"
                    >
                      Development
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/digital-marketing"
                      onClick={() =>
                        window.scroll({
                          top: 0,
                          behavior: "instant",
                        })
                      }
                      aria-label="Visit Digital Page"
                      rel="preload"
                    >
                      Marketing
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/cloud-computing"
                      onClick={() =>
                        window.scroll({
                          top: 0,
                          behavior: "instant",
                        })
                      }
                      aria-label="Visit Cloud Page"
                      rel="preload"
                    >
                      Cloud Computing
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/web-3"
                      onClick={() =>
                        window.scroll({
                          top: 0,
                          behavior: "instant",
                        })
                      }
                      aria-label="Visit Web Page"
                      rel="preload"
                    >
                      Web 3
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/web"
                      onClick={() =>
                        window.scroll({
                          top: 0,
                          behavior: "instant",
                        })
                      }
                      aria-label="Web"
                      rel="preload"
                    >
                      Resource Augmentation
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="foot-links-inner">
                <ul>
                  <li className="sap-sm-heading">Case Studies</li>
                  <li>
                    <Link
                      to="/case-study/automobile"
                      onClick={() =>
                        window.scroll({
                          top: 0,
                          behavior: "instant",
                        })
                      }
                      rel="preload"
                    >
                      Automobile
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/case-study/finance"
                      onClick={() =>
                        window.scroll({
                          top: 0,
                          behavior: "instant",
                        })
                      }
                      rel="preload"
                    >
                      Finance
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/case-study/hotels-hospitality"
                      onClick={() =>
                        window.scroll({
                          top: 0,
                          behavior: "instant",
                        })
                      }
                      rel="preload"
                    >
                      Hotels & Hospitality
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/case-study/sports"
                      onClick={() =>
                        window.scroll({
                          top: 0,
                          behavior: "instant",
                        })
                      }
                      rel="preload"
                    >
                      Sports
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/case-study/automobile"
                      onClick={() =>
                        window.scroll({
                          top: 0,
                          behavior: "instant",
                        })
                      }
                      rel="preload"
                    >
                      and more...
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="foot-links-inner" id="foot-links-multi">
                <ul>
                  <li className="sap-sm-heading">Locate Us</li>
                  <li>
                    <Link
                      to="https://goo.gl/maps/1iTmfkKVgoDuKDds6"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Plot No I-35, IT City, Sector 83 A,
                      <br />
                      Mohali, Punjab 140306
                    </Link>
                  </li>
                </ul>
                <ul>
                  <li className="sap-sm-heading">Let's have a Call!</li>
                  <li>
                    <Link to="tel:+917743000840">+91 77430 00840</Link>
                  </li>
                  <li>
                    <Link to="tel:+911724081758">+91 172 408 1758</Link>
                  </li>
                  {/* <li>
                    <Link to="tel:+17788079893">+1 778 807 9893</Link>
                  </li> */}
                </ul>
                <ul>
                  <li className="sap-sm-heading">Let's Talk!</li>
                  <li>
                    <Link to="mailto:info@kindlebit.com">info@kindlebit.com</Link>
                  </li>
                  <li>
                    <Link to="mailto:support@kindlebit.com">
                      support@kindlebit.com
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="foot-right">
            <div className="foot-sub">
              <div className="sec-heading">
                <div className="sap-caption-head">
                  <div className="sap-caption">get our latest updates</div>
                </div>
                <div className="sap-lg-heading">
                  Subscribe To
                  <br />
                  Our Newsletter
                </div>
              </div>
              <form className="foot-sub-form">
                <div className="form-group">
                  <input
                    type="text"
                    value={emaildata}
                    onChange={(e) => setEmaildata(e.target.value)}
                    className="form-control"
                    placeholder="Enter your mail..."
                  />
                </div>
                <div className="sap-btn-light">
                  <button type="button" onClick={() => handleSendEmail()} aria-label="Send">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19.207"
                      height="11.624"
                      viewBox="0 0 19.207 11.624"
                    >
                      <path
                        id="Union_7"
                        data-name="Union 7"
                        d="M4.812,0,9.624,4.812Zm0,0L0,4.812Z"
                        transform="translate(18.207 1) rotate(90)"
                        fill="rgba(0,0,0,0)"
                        stroke="#00224b"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_10"
                        data-name="Line 10"
                        y2="16.875"
                        transform="translate(17.875 5.812) rotate(90)"
                        fill="rgba(0,0,0,0)"
                        stroke="#00224b"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      />
                    </svg>
                  </button>
                </div>
              </form>
            </div>
            <div className="foot-social-links">
              <ul>
                <li>
                  <Link
                    to="https://www.facebook.com/KindleBit"
                    rel="noreferrer"
                    target="_blank"
                    aria-label="Facebook"
                  >
                    <i className="fa-brands fa-facebook-f"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://twitter.com/KindleBit"
                    rel="noreferrer"
                    target="_blank"
                    aria-label="Twitter"
                  >
                    <i class="fa-brands fa-x-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://instagram.com/kindlebit_solutions"
                    rel="noreferrer"
                    target="_blank"
                    aria-label="Instagram"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://in.linkedin.com/company/kindlebit-solutions"
                    rel="noreferrer"
                    target="_blank"
                    aria-label="LinkedIn"
                  >
                    <i className="fa-brands fa-linkedin-in"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <a
          class="whatsapp-button"
          href="whatsapp://send?phone=+917743000840&text=Hello!"
          target="_blank"
          title="Chat with us on WhatsApp"
        >
          <i class="fab fa-whatsapp"></i>
        </a>
        <div className="foot-bot">
          <ul>
            <li>© {new Date().getFullYear()} Kindlebit Solutions Pvt. Ltd.</li>
            <li
              onClick={() => SetTermsModalstate(true)}
              style={{ cursor: "pointer" }}
            >
              Terms of Use
            </li>
            <li
              onClick={() => navigate("/privacy-policy")}
              style={{ cursor: "pointer" }}
            >
              Privacy Policy
            </li>
            <li
              onClick={() => setCookiePolicyModalState(true)}
              style={{ cursor: "pointer" }}
            >
              Cookie Policy
            </li>
          </ul>
        </div>
      </footer>
      {/* {Cookie Modal} */}
      {CookiePolicyModalstate && (
        <CookiePolicyModal
          CookiePolicyModalstate={CookiePolicyModalstate}
          setCookiePolicyModalState={setCookiePolicyModalState}
        />
      )}
      {/* {Privacy Modal} */}
      {PrivacyPolicyModalstate && (
        <PrivacyPolicyModal
          PrivacyPolicyModalstate={PrivacyPolicyModalstate}
          SetPrivacyPolicyModalstate={SetPrivacyPolicyModalstate}
        />
      )}
      {/* TermsModalstate */}
      {TermsModalstate && (
        <TermsModal
          TermsModalstate={TermsModalstate}
          SetTermsModalstate={SetTermsModalstate}
        />
      )}
    </>
  );
}
export default Footer;
